import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'
import './Dashboard.css';

const ProviderRegistration = () => {

	const navigate = useNavigate(); // 2. Initialize

	const [formData, setFormData] = useState({
		name: '', email: '', password: '', phone: '',
		serviceType: '', serviceSubType: '', experience: 0,
		chargeType: '', city: '', area: '', state: '', charge: '',
		nonVegCharge: '', vegCharge: '', banquetCharge: '',
		serviceCities: [], pincode: ''
	});

	const [options, setOptions] = useState({ serviceTypes: [], subTypes: [], chargeTypes: [], subTypeForBanquet: [], showServiceSubTypeFor: [], subTypeForEvent: [], subTypeForLawyer: [] });
	const [errors, setErrors] = useState({});
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [warnings, setWarnings] = useState({});

	// Fetch dynamic options from backend
	useEffect(() => {
		fetch("/api/v1/loader/load")
			.then(res => res.json())
			.then(data => setOptions({
				serviceTypes: data.serviceType || [],
				subTypes: data.serviceSubType || [],
				chargeTypes: data.chargeType || [],
				showServiceSubTypeFor: data.showServiceSubTypeFor || [],
				subTypeForEvent: data.subTypeForEvent || [],
				subTypeForLawyer: data.subTypeForLawyer || [],
				subTypeForBanquet: data.subTypeForBanquet || []
			}))
			.catch(err => console.error("Error loading form data:", err));
	}, []);

	// Immediate validation on "Finish Typing" (Blur)
	const validateField = (name, value) => {
		let error = "";
		if (name === 'phone' && !/^[6-9]\d{9}$/.test(value)) {
			error = "Invalid 10-digit Indian phone number.";
		} else if (name === 'pincode' && !/^[1-9][0-9]{5}$/.test(value)) {
			error = "Invalid 6-digit Pincode.";
		} else if (name === 'email' && !/\S+@\S+\.\S+/.test(value)) {
			error = "Invalid email format.";
		} else if (name === 'services') {
			const trimmedValue = value.trim();

			if (!trimmedValue) {
				error = "At least one service is required.";
			} else if (trimmedValue.includes(' ') && !trimmedValue.includes(',')) {
				setWarnings(prev => ({ ...prev, services: "Tip: Use commas to separate services for better visibility." }));
			} else {
				// Clear warning if they fix it
				setWarnings(prev => ({ ...prev, services: "" }));
			}
		} else if (name === 'serviceCities') {
			// Validation: Must be comma separated (at least one comma if multiple, or just no illegal chars)
			if (!value.trim()) {
				error = "At least one city is required.";
			} /*else if (value.includes(' ') && !value.includes(',')) {
				error = "Please separate multiple cities with commas (e.g., Pune, Mumbai).";
			}*/
		}
		setErrors(prev => ({ ...prev, [name]: error }));
	};


	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData(prev => ({ ...prev, [name]: value }));
		if (errors[name]) setErrors(prev => ({ ...prev, [name]: "" }));
	};

	const handleBlur = (e) => validateField(e.target.name, e.target.value);

	// Final check: If any error exists in state OR a required field is empty
	const isFormInvalid = () => {
		const hasErrors = Object.values(errors).some(error => error !== "");
		const requiredFields = ['name', 'email', 'password', 'phone', 'serviceType', 'serviceCities', 'city', 'area', 'state'];
		const isMissingFields = requiredFields.some(field => !formData[field]);
		return hasErrors || isMissingFields;
	};

	const getOrGenerateDeviceId = () => {
		let deviceId = localStorage.getItem('deviceId');
		if (!deviceId) {
			// Use crypto.randomUUID() for modern browsers
			deviceId = window.crypto.randomUUID ? window.crypto.randomUUID() : 'manual-fallback-uuid-' + Date.now();
			localStorage.setItem('deviceId', deviceId);
		}
		return deviceId;
	};

	const handleSubmit = async (e) => {

		e.preventDefault();
		setIsSubmitting(true);

		const deviceId = getOrGenerateDeviceId();

		// Create a copy of the data
		const payload = { ...formData };

		// Remove serviceSubType if it's empty to avoid Spring Enum errors

		if (!payload.serviceSubType) {
			delete payload.serviceSubType;
		}

		if (payload.phone && !payload.phone.startsWith("+91")) {
			payload.phone = `+91${payload.phone}`;
		}

		// Convert comma string to List
		/*payload.serviceCities = typeof payload.serviceCities === 'string'
			? payload.serviceCities.split(',').map(c => c.trim()).filter(c => c !== "")
			: payload.serviceCities;*/

		try {
			let response = await fetch('/api/v1/provider/register', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', 'X-Device-Id': deviceId },
				body: JSON.stringify(payload) // Send the cleaned payload
			});

			if (response.ok) {

				// Matches your AuthResponse POJO structure
				const { accessToken, refreshToken, tokenType } = await response.json();

				localStorage.setItem('accessToken', accessToken);
				localStorage.setItem('refreshToken', refreshToken);
				localStorage.setItem('tokenType', tokenType);

				// ✅ Fire Google Ads Conversion
				if (window.gtag) {
					window.gtag('event', 'conversion', {
						'send_to': 'AW-17999708223/jiF2CNC066ccEL-A94ZD'
					});
				}

				navigate("/dashboard")
			} else if (response.status === 400) {

				const serverErrors = await response.json();
				alert(serverErrors.message);

			} else {
				alert("An unexpected error occurred.");
			}
		} catch (error) {
			alert("Network error, please try again. !!!");
		} finally {
			setIsSubmitting(false);
		}
	};

	return (
		<div className="registration-container">
			<form className="registration-form" onSubmit={handleSubmit}>
				<button type="button" className="home-btn" onClick={() => navigate('/')}>
					← Home
				</button>
				<p style={{ textAlign: 'right' }}>
					Do You have an account? <span style={{ color: '#4f46e5', cursor: 'pointer' }} onClick={() => navigate('/login')}>Login here</span>
				</p>
				<h2>Professionals Registration</h2>

				<div className="form-group">
					<input name="name" placeholder="Full Name" onChange={handleChange} required />
				</div>

				<div className="form-group">
					<input name="email" type="email" placeholder="Email" onBlur={handleBlur} onChange={handleChange} required />
					{errors.email && <span className="error-text">{errors.email}</span>}
				</div>
				<div className="form-group"> <input name="password" type="password" placeholder="Password" onChange={handleChange} required /> </div>




				<div className="form-group">
					{/* Label goes here if you have one */}
					<div className="phone-input-wrapper">
						<span className="prefix">+91</span>
						<input
							name="phone"
							type="tel"
							placeholder="10-digit Phone"
							onBlur={handleBlur}
							onChange={handleChange}
							required
							maxLength="10"
						/>
					</div>
					{errors.phone && <span className="error-text">{errors.phone}</span>}
				</div>



				<div className="form-group">
					<select name="serviceType" onChange={handleChange} required>
						<option value="">Select Service Type</option>
						{options.serviceTypes.map(t => <option key={t} value={t}>{t}</option>)}
					</select>
				</div>



				{options.showServiceSubTypeFor.includes(formData.serviceType) && (
					<div className="form-group">
						<select name="serviceSubType" onChange={handleChange}>
							<option value="">Select Specialization</option>
							{formData.serviceType === 'Lawyer' ? options.subTypeForLawyer.map(s => <option key={s} value={s}>{s}</option>)
								: formData.serviceType === 'Event Planner' ? options.subTypeForEvent.map(s => <option key={s} value={s}>{s}</option>)
									: options.subTypes.map(s => <option key={s} value={s}>{s}</option>)
							}
						</select>
					</div>
				)}

				<div className="form-group"><input name="experience" type="number" min="0" placeholder="Experience (Years)" onChange={handleChange} required /> </div>

				<div className="form-group"> <select name="chargeType" onChange={handleChange}>
					<option value="">Select Charge Type(optional)</option>
					{options.chargeTypes.map(charge => <option key={charge} value={charge}>{charge} </option>)}
				</select> </div>


				{options.subTypeForBanquet.includes(formData.serviceType) ? (
					<div className="form-group">
						<input
							type="number"
							name="vegCharge"
							placeholder="Veg Charge Per Plate"
							value={formData.vegCharge || ''}
							onChange={handleChange}
						/>
						<input
							type="number"
							name="nonVegCharge"
							placeholder="Non Veg Charge Per Plate"
							value={formData.nonVegCharge || ''}
							onChange={handleChange}
						/>
						{formData.serviceType != 'Catering Service' &&
							<input
								type="number"
								name="banquetCharge"
								placeholder="Any Fixed Banquet Hall Charge (Optional)"
								value={formData.banquetCharge || ''}
								onChange={handleChange}
							/>
						}

					</div>
				) : (
					<div className="form-group">
						<input
							name="charge"
							placeholder="Charge Amount (Optional)"
							value={formData.charge || ''}
							onChange={handleChange}
						/>
					</div>
				)}



				{/*<div className="form-group">
					<textarea
						name="services"
						placeholder="Services (e.g. Service1, Service2)(optional)"
						onBlur={handleBlur}
						onChange={handleChange}
						className={errors.services ? 'input-error' : warnings.services ? 'input-warning' : ''}
					/>
					{ Display logic }
					{errors.services ? (
						<span className="error-text">{errors.services}</span>
					) : warnings.services ? (
						<span className="warning-text">{warnings.services}</span>
					) : null}
				</div>*/}


				<div className="form-group">
					<textarea
						name="services"
						placeholder="Services (e.g. Service1, Service2)(optional)"
						maxLength={200} // Strictly prevents typing beyond 200
						onBlur={handleBlur}
						onChange={handleChange}
						value={formData.services} // Assumes your state is stored in 'values'
						className={errors.services ? 'input-error' : warnings.services ? 'input-warning' : ''}
					/>

					<div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '4px' }}>
						{/* Error/Warning Logic */}
						<div>
							{errors.services ? (
								<span className="error-text">{errors.services}</span>
							) : warnings.services ? (
								<span className="warning-text">{warnings.services}</span>
							) : null}
						</div>

						{/* Character Counter */}
						<span style={{
							fontSize: '12px',
							color: (formData.services?.length >= 200) ? 'red' : '#636e72'
						}}>
							{formData.services?.length || 0}/200
						</span>
					</div>
				</div>


				<div className="form-group">
					<textarea
						name="serviceCities"
						placeholder="Service Cities (e.g. city1, city2, ALL INDIA)(Required)"
						onBlur={handleBlur}
						onChange={handleChange}
						required
					/>
					{errors.serviceCities && <span className="error-text">{errors.serviceCities}</span>}
				</div>

				<div className="form-group"> <input name="city" placeholder="Your City(Required)" onChange={handleChange} required /> </div>
				<div className="form-group"> <input name="area" placeholder="Your Area(Required)" onChange={handleChange} required /> </div>
				<div className="form-group"> <input name="state" placeholder="Your State(Required)" onChange={handleChange} required /> </div>


				{/*<div className="form-group">
					<input name="pincode" placeholder="Pincode(Required)" onBlur={handleBlur} onChange={handleChange} required />
					{errors.pincode && <span className="error-text">{errors.pincode}</span>}
				</div>*/}

				<button
					type="submit"
					disabled={isFormInvalid() || isSubmitting}
					className="submit-btn"
				>
					{isSubmitting ? <div className="loader"></div> : "Register Now"}
				</button>

			</form>
		</div>
	);
};

export default ProviderRegistration;
